import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable, Subject } from 'rxjs';
import { IPageableResponse } from '../../../global/pagging.dto';
import { ITemplatesSearchUserDto, IUserGroupDto } from '../../../store/actions/IUser-data.dto';
import { Template, TemplateDetails, TemplateRole } from '../documents/dto/document-details.dto';
import { BCC, TemplateSettings } from '../edit-template/edit-template.dto';
import { IBrandingDto } from '../settings/branding/branding.dto';
import { TemplateType } from './template.dto';
import { ISection } from '../settings/documenttype/document-type-settings-modal/document-type-settings.dto';
@Injectable({
    providedIn: 'root'
})

export class TemplateService {
    constructor(private http: HttpClient) {
        
    }
    private filters = new Subject<{filters:ITemplateFilters}>(); //need to create a subject
    /**
    * add new template
    * @params formData
    */
    addNewTemplate(form) {
        return this.http.post<IAddTemplateResponse>(`templates`, form);
    }
        
    
    /**
     * get all listing
     * @params page & queryString
     */
    templateListing(page:number, q:string, filter:ITemplateFilters = {}, p: string = ''){
        const params = new HttpParams()
        .set('page', page.toString())
        .set('q', q)
        .set('p', p)
        .set('document_type_id', filter?.document_type_id ?? '')
        .set('language', filter?.language ?? 'all')
        .set('type', filter?.template_type ?? 'all')
        .set('status', filter?.status ?? 'all');
        return this.http.get<IPageableResponse<IGetTemplateListItem> | IGetTemplateListItem[]>(`templates`, { params });
    }

    /**
     * If a template is public then it will appear on “send new” for its shared user and owner
     * @param page 
     * @param q 
     * @param filter 
     * @returns 
     */
    publishedOrSharedWith(page:number, q:string, filter:ITemplateFilters = {}){
        return this.http.get(`templates/select-templates?page=${page}&q=${q}&document_type_id=${filter?.document_type_id ?? ''}&language=${filter?.language ?? 'all'}`);
    }
    
    
    /**
     * published/draft template
     * @params data
     */
    publishTemplate(data: {id:number, status: 0 | 1}){
        return this.http.post<{message:string}>(`templates/${data?.id}/toggle-status`,data);
    }



    /**
     * Delete template
     * @params id
     */
    deleteTemplate(id: number){
        return this.http.delete(`templates/${id}`);
    }



    /**
     * Duplicate template
     * @param formData 
     * @returns 
     */
    duplicateTemplate(formData: { id: number }){
        return this.http.post<IGetTemplateListItem>(`templates/${formData?.id}/duplicate`, formData);
    }
    
    /**
     * the component that wants to update something, calls this fn
     * @param filters 
     */
    onSetFilters(filters){
        this.filters.next({ filters: filters }); //next() will feed the value in Subject
    }
    
    /**
     * the receiver component calls this function 
     */
    onGetFilters(): Observable<{filters:ITemplateFilters}> {
        return this.filters.asObservable(); //it returns as an observable to which the receiver function will subscribe
    }

    /**
     * search the users or group for share template
     * @param query 
     * @returns array
     */
    searchUsers(query: string, templateId: number){
        return this.http.get<ITemplatesSearchUserResponse>(`templates/search-user?q=${query}&template_id=${templateId}`);
    }
}

export interface ITemplatesSearchUserResponse {
    groups?: IUserGroupDto[];
    users?: ITemplatesSearchUserDto[] | null;
}

export interface ITemplateFilters{
    document_type_id?: number | string;
    language?: string;
    template_type?: TemplateType;
    status?: number;
}

export interface IAddTemplateResponse{
    category_id?: number | null;
    content: string;
    created_at: string;
    document_type_id?: number | null;
    id: number;
    name: string;
    thumbnail?: null | string;
    updated_at: string;
    user_id: number;
    workspace_id: number;
}

export interface IGetTemplateListItem{
    bcc?: BCC;
    template?: Template;
    template_details?: TemplateDetails;
    template_fields_datas?: null | TemplateFieldsDatas;
    template_roles?: TemplateRole[];
    layout_settings?: ISection;  // Optional: legacy templates may not have this
    template_settings?: null | TemplateSettings;
    status?: 0 | 1,
    branding: IBrandingDto
}

export interface TemplateFieldsDatas {
    created_at: string;
    data: { [key: string]: unknown };
    dataable_id: number;
    dataable_type: string;
    id: number;
    template_id?: number | null;
    updated_at: string;
    user_id: number;
    workspace_id: number;
}
